import { concat } from 'rxjs';
import { sendingRequestObservable } from './sending-request-actions';

// prettier-ignore
export const sendingAsyncRequest = request => concat(
  sendingRequestObservable(true, true),
  request,
  sendingRequestObservable(false),
);
